import React from "react";

import { IgSelect, IgTooltip, IgTypography } from "@intelligems/ig-theme";
import { StatSigViewType } from "@intelligems/ig-types";
import { InfoOutlined } from "@mui/icons-material";
import { Grid, IconButton, MenuItem } from "@mui/material";

interface StatSigFilterProps {
  statSigView: StatSigViewType;
  onStatSigSwitch: (statSigView: StatSigViewType) => void;
}
export const StatSigFilter = ({
  statSigView,
  onStatSigSwitch,
}: StatSigFilterProps) => {
  return (
    <Grid
      item
      container
      direction={"row"}
      alignItems={"center"}
      columnSpacing={1}
    >
      <Grid item>
        <IgTypography sx={{ fontSize: "14px", fontWeight: 600 }}>
          View Type:
        </IgTypography>

        <IgTooltip
          title={
            "Controls whether probabilities shown are the probability to be best, or the probability to beat control."
          }
        >
          <IconButton aria-label="info" size={"small"}>
            <InfoOutlined fontSize={"small"} />
          </IconButton>
        </IgTooltip>
      </Grid>
      <Grid item>
        <IgSelect
          sx={{ fontSize: "14px" }}
          size={"small"}
          onChange={(e) => {
            onStatSigSwitch(e.target.value as StatSigViewType);
          }}
          value={statSigView ?? "best"}
          fullWidth={true}
        >
          <MenuItem value={"best"} sx={{ fontSize: "14px" }}>
            Best
          </MenuItem>
          <MenuItem sx={{ fontSize: "14px" }} value={"beatControl"}>
            Beat Control
          </MenuItem>
        </IgSelect>
      </Grid>
    </Grid>
  );
};
